export default __webpack_public_path__ + "46e2fe641c0465d540490b5fe478c056.webp";